<template>
       <div>
          <b-button class="float-left"  variant ="outline-secondary" @click="previousStep()" v-if="!isFirstStep">Previous</b-button>
          <b-button class="float-right" variant ="outline-primary" @click="nextStep(step)" v-if="!isLastStep">Next</b-button>
           <b-button class="float-right" variant ="primary" @click="nextStep(step)" v-if="isLastStep">Enregistrer</b-button>
        </div>
</template>

<script>
export default {
  props:{
    isFirstStep:{
      type : Boolean,
      default : false
    },
    previousStep : Function,
    nextStep : Function,
    isLastStep:{
      type : Boolean,
      default : false
    },
    step : Number
  }
}
</script>